<template>
  <div class="editPage">
    <div class="title">{{$t('lang.setting.myInfo')}}</div>
    <div class="editContainer">
      <div class="row">
        <div class="caption">
          {{$t('lang.login.username')}}
        </div>
        <div class="inputRow">
          <div>
            <label>
              <input type="text" v-model="userInfo.UserName">
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="caption">
          {{$t('lang.login.email')}}
        </div>
        <div class="inputRow">
          <div>
            <label>
              <input :class="{readOnly: userType === 'email'}" type="text" :readonly="userType === 'email'" v-model="userInfo.Email">
            </label>
          </div>
        </div>
      </div>
      <div class="row" style="display: flex">
        <div style="flex: 1;margin-right: 30px;">
          <div class="caption">
            {{$t('lang.setting.mobile')}}
          </div>
          <div class="inputRow">
            <div>
              <div class="select">
                <div class="input" :class="{readOnly: userType === 'mobile'}">+{{userInfo.CountryCode}}</div>
                <img class="pointer" :src="triangle" :class="{rotate: showSelect}" alt="" @click.stop="showSelect = !showSelect" v-if="userType === 'email'">
                <div class="selectList" v-show="showSelect">
                  <div class="option pointer" v-for="(item, index) in countryCodeList" :key="index" @click="select('CountryCode', item.value)">{{item.label}}</div>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input :class="{readOnly: userType === 'mobile'}" type="text" :readonly="userType === 'mobile'" v-model="userInfo.telNum">
              </label>
            </div>
          </div>
        </div>
        <div style="flex: 1">
          <div class="caption">
            {{$t('lang.setting.depositCurrency')}}
          </div>
          <div class="inputRow">
            <div class="readOnly">{{userInfo.CurrencyName}} {{fetchCurrency[userInfo.CurrencyName]}}</div>
          </div>
        </div>
      </div>
      <div>
        <div class="submit" @click="update">{{$t('lang.setting.save')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import {countryCodeList, fetchCurrency} from '@/constant'
import {mapMutations} from 'vuex'
import triangle from '@/assets/images/common/triangle.svg'
export default {
  name: 'Edit',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      showSelect: false,
      countryCodeList,
      fetchCurrency,
      triangle,
      userType: ''
    }
  },
  mounted () {
    request('post', '/innovation/account/getuserinfo', {
      userId: this.userInfo.UserId
    }).then(res => {
      console.log(res)
      this.userInfo = {
        ...this.userInfo,
        ...res
      }
      switch (this.userInfo.UserType) {
        case undefined:
        case '1':
          this.userType = 'mobile'
          break
        case '2':
        case '3':
          this.userType = 'email'
          break
      }
    })
  },
  methods: {
    ...mapMutations({
      updateUserName: 'updateUserName'
    }),
    select (type, val) {
      this.userInfo[type] = val
      this.showSelect = false
    },
    update () {
      if (!this.userInfo.UserName) return
      request('put', '/innovation/account/updateuserinfo', {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        ...this.userInfo
      }).then(res => {
        localStorage.setItem('userInfo', JSON.stringify({
          ...JSON.parse(localStorage.getItem('userInfo')),
          ...res
        }))
        this.updateUserName(res.UserName)
        this.$message.success(this.$t('lang.setting.saveSuccess'))
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .editPage {
    .title {
      font-family: Roboto-Medium, sans-serif;
      font-size: 22px;
      line-height: 26px;
      color: #F6D9AA;
      font-weight: 500;
      margin-bottom: 30px;
    }
    .editContainer {
      .row {
        margin-top: 30px;
        margin-bottom: 30px;
        .caption {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
        }
        .inputRow {
          display: flex;
          >div {
            flex: 1;
            font-size: 16px;
            color: #fff;
            text-align: center;
            line-height: 40px;
            border: 1px solid rgba(246, 217, 170, 0.5);
            border-radius: 6px;
            padding: 0 10px;
            letter-spacing: 0.1em;
            &:not(:first-child) {
              margin-left: 10px;
              flex: 4;
            }
            input {
              width: 100%;
              font-size: 16px;
              color: #fff;
              text-align: center;
              letter-spacing: 0.1em;
            }
            .select {
              position: relative;
              display: flex;
              align-items: center;
              font-size: 16px;
              line-height: 40px;
              color: #ffffff;
              text-align: center;
              letter-spacing: normal;
              .input {
                flex: 1;
                text-align: left;
              }
              img {
                height: 14px;
                width: 12px;
                transition: transform .3s;
              }
              .selectList {
                position: absolute;
                left: -10px;
                top: 50px;
                padding: 15px 0;
                width: max-content;
                text-align: left;
                background: #202020;
                border: 1px solid rgba(246, 217, 170, 0.5);
                border-radius: 0 0 10px 10px;
                cursor: default;
                .option {
                  padding: 0 15px;
                  line-height: 30px;
                  &:hover {
                    background: #333;
                  }
                }
              }
              .rotate {
                transform: translateY(-50%) ;
                transform: rotate(90deg);
              }
            }
          }
          .readOnly {
            color: #909399;
          }
        }
      }
      .submit {
        float: right;
        margin-top: 30px;
        width: 150px;
        font-size: 22px;
        line-height: 50px;
        color: #000D2E;
        text-align: center;
        background-color: #F6D9AA;
        border-radius: 6px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Edit/index.vue